// private property
let _keyStr =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

/**
 * UTF-8编码方法
 */
const utf8 = {
  /**
   *  转为UTF-8编码
   * @param {*} string
   * @returns
   */
  encode: (string) => {
    string = string.replace(/\r\n/g, '\n');
    let utftext = '';
    for (let n = 0; n < string.length; n++) {
      let c = string.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }
    }
    return utftext;
  },
  /**
   * uft8 解码
   * @param {*} utftext
   * @returns
   */
  decode: (utftext) => {
    var string = '';
    var i = 0;
    var c, c2, c3;
    while (i < utftext.length) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode(
          ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );
        i += 3;
      }
    }
    return string;
  }
};

/**
 * 兼容C#算法
 */
const base64 = {
  /**
   * 加密64
   * @param {*} input 原文内容
   * @returns
   */
  encode: (input) => {
    var output = '';
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = utf8.encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output =
        output +
        _keyStr.charAt(enc1) +
        _keyStr.charAt(enc2) +
        _keyStr.charAt(enc3) +
        _keyStr.charAt(enc4);
    }
    return output;
  },
  /**
   * 解密
   * @param {*} input 原文内容
   * @returns
   */
  decode: (input) => {
    var output = '';
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
    while (i < input.length) {
      enc1 = _keyStr.indexOf(input.charAt(i++));
      enc2 = _keyStr.indexOf(input.charAt(i++));
      enc3 = _keyStr.indexOf(input.charAt(i++));
      enc4 = _keyStr.indexOf(input.charAt(i++));
      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;
      output = output + String.fromCharCode(chr1);
      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }
    }
    output = utf8.decode(output);
    return output;
  }
};

export { base64, utf8 };

// 0.4.1 版本以下方法，不兼容C#
// /**
//  * base64 编码
//  * @param {string} str 需要编码的内容
//  * @param {string} encodeChars 自定义字典，默认为空
//  */
//  const base64Encode = (str, encodeChars) => {
//     encodeChars =
//       encodeChars ||
//       'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
//     var out, i, len;
//     var c1, c2, c3;
//     len = str.length;
//     i = 0;
//     out = '';
//     while (i < len) {
//       c1 = str.charCodeAt(i++) & 0xff;
//       if (i === len) {
//         out += encodeChars.charAt(c1 >> 2);
//         out += encodeChars.charAt((c1 & 0x3) << 4);
//         out += '==';
//         break;
//       }
//       c2 = str.charCodeAt(i++);
//       if (i === len) {
//         out += encodeChars.charAt(c1 >> 2);
//         out += encodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
//         out += encodeChars.charAt((c2 & 0xf) << 2);
//         out += '=';
//         break;
//       }
//       c3 = str.charCodeAt(i++);
//       out += encodeChars.charAt(c1 >> 2);
//       out += encodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
//       out += encodeChars.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6));
//       out += encodeChars.charAt(c3 & 0x3f);
//     }
//     return out;
//     // let encodeChars =
//     //   'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

//     // let out, i, len
//     // let c1, c2, c3
//     // len = str.length
//     // i = 0
//     // out = ''
//     // while (i < len) {
//     //   c1 = str.charCodeAt(i++) & 0xff
//     //   if (i === len) {
//     //     out += encodeChars.charAt(c1 >> 2)
//     //     out += encodeChars.charAt((c1 & 0x3) << 4)
//     //     out += '=='
//     //     break
//     //   }
//     //   c2 = str.charCodeAt(i++)
//     //   if (i === len) {
//     //     out += encodeChars.charAt(c1 >> 2)
//     //     out += encodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4))
//     //     out += encodeChars.charAt((c2 & 0xf) << 2)
//     //     out += '='
//     //     break
//     //   }
//     //   c3 = str.charCodeAt(i++)
//     //   out += encodeChars.charAt(c1 >> 2)
//     //   out += encodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4))
//     //   out += encodeChars.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6))
//     //   out += encodeChars.charAt(c3 & 0x3f)
//     // }
//     // return out
//   };

//   /**
//    *  base64 解码
//    * @param {string} str 需要解码的内容
//    * @param {Array} decodeChars 解码字典
//    */
//   const base64Decode = (str, decodeChars) => {
//     decodeChars = decodeChars || [
//       -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
//       -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
//       -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60,
//       61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
//       13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1,
//       26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44,
//       45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1
//     ];

//     let c1, c2, c3, c4;
//     let i, len, out;
//     len = str.length;
//     i = 0;
//     out = '';
//     while (i < len) {
//       /* c1 */
//       do {
//         c1 = decodeChars[str.charCodeAt(i++) & 0xff];
//       } while (i < len && c1 === -1);
//       if (c1 === -1) break;
//       /* c2 */
//       do {
//         c2 = decodeChars[str.charCodeAt(i++) & 0xff];
//       } while (i < len && c2 === -1);
//       if (c2 === -1) break;
//       out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));
//       /* c3 */
//       do {
//         c3 = str.charCodeAt(i++) & 0xff;
//         if (c3 === 61) return out;
//         c3 = decodeChars[c3];
//       } while (i < len && c3 === -1);
//       if (c3 === -1) break;
//       out += String.fromCharCode(((c2 & 0xf) << 4) | ((c3 & 0x3c) >> 2));
//       /* c4 */
//       do {
//         c4 = str.charCodeAt(i++) & 0xff;
//         if (c4 === 61) return out;
//         c4 = decodeChars[c4];
//       } while (i < len && c4 === -1);
//       if (c4 === -1) break;
//       out += String.fromCharCode(((c3 & 0x03) << 6) | c4);
//     }
//     return out;
//   };
